<!--公共列表-->
<template>
  <div class="list-wrapper">
    <!-- 筛选 -->
    <div class="main-filters" v-if="filter">
      <el-form :inline="true" :model="param" @submit.native.prevent>
        <template v-for="(item, index) in filter">
          <!--input-->
          <el-form-item :label="item.labelName" v-if="item.type === 'input'" :prop="item.key" :key="index">
            <el-input v-model="param[item.key]" :placeholder="item.placeholder" @keyup.native.enter.prevent="search"></el-input>
          </el-form-item>
          <!--select-->
          <el-form-item :label="item.labelName" v-if="item.type === 'select'" :prop="item.key" :key="index">
            <el-select v-model="param[item.key]" :placeholder="item.placeholder" @change="search">
              <el-option v-for="option in item.options" :label="option.label" :value="option.value" :key="option.value"></el-option>
            </el-select>
          </el-form-item>
          <!--cascader-->
          <el-form-item :label="item.labelName" v-if="item.type === 'cascader'" :prop="item.key" :key="index">
            <el-cascader v-model="param[item.key]" :options="item.options" :props="item.props" clearable change-on-select @change="search"></el-cascader>
          </el-form-item>
          <!-- city components -->
          <el-form-item :label="item.labelName" v-if="item.type === 'city'" :prop="item.key" :key="index">
            <app-city v-model="param[item.key]" :placeholder="item.placeholder" @change="search"></app-city>
          </el-form-item>
          <!--selectInput-->
          <el-form-item v-if="item.type === 'selectInput'" :prop="item.key" :key="index">
            <el-select v-model="selectInput" @change="changeSelectInput" style="width:104px">
              <el-option v-for="option in item.options" :label="option.label" :value="option.value" :key="option.value"></el-option>
            </el-select>
            <el-input v-model="param[selectInput]" :placeholder="item.placeholder" @keyup.native.enter.prevent="search" style="width:200px"></el-input>
          </el-form-item>
          <!-- datePicker -->
          <el-form-item :label="item.labelName" v-if="item.type === 'datePicker'" :prop="item.key" :key="index">
            <el-date-picker v-model="param[item.key]" :editable="item.props.editable" :clearable="item.props.clearable" :type="item.props.type" :placeholder="item.placeholder" @change="changeDatePicker(item.key)" :ref="'datePicker_' + item.key" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <!--button-->
          <el-form-item v-if="item.type === 'button'" :key="index">
            <el-button type="primary" @click="search" v-if="item.isSearch">
              <i class="el-icon-search"></i> {{item.value}}</el-button>
            <el-tooltip placement="right" v-else>
              <div slot="content">{{item.tips}}</div>
              <el-button type="primary" @click="item.fn()">
                <i class="el-icon-plus"></i> {{item.value}}</el-button>
            </el-tooltip>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <!-- 表主体 -->
    <div class="main-table" v-loading="isLoading" element-loading-text="拼命加载中">
      <!-- 列表项 -->
      <div class="list-block-control" v-if="tableCode" @click="openListItem">
        <i class="el-icon-caret-top"></i>
        <span>显示列表项</span>
      </div>
      <!-- table -->
      <el-table :data="dataList" border stripe resizable @selection-change="handleSelectionChange" @select="handleSelect" :row-key="setRowKey" @row-click="rowClick" @select-all="handleSelectAll">
        <slot name="expand"></slot>
        <!-- checkbox -->
        <el-table-column type="selection" width="46" v-if="isCheckbox"></el-table-column>
        <!-- radio -->
        <el-table-column width="46" align="center" v-if="isRadio">
          <template slot-scope="scope">
            <el-radio v-model="radio" :label="scope.row.id" @change="changeRadio(scope.row)" class="list-radio"></el-radio>
          </template>
        </el-table-column>
        <!-- 编号 -->
        <el-table-column type="index" label="编号" width="66" align="center" header-align="center" v-if="isShowNum"></el-table-column>
        <template v-for="(item, index) in tableHeadColumn">
          <!-- 索引 -->
          <el-table-column v-if="item.type" :label="item.name" :type="item.type" :width="item.width" :key="index" align="center" header-align="center"></el-table-column>
          <!-- 列表字段 -->
          <template v-else-if="item.code">
            <!--图片-->
            <el-table-column :prop="item.code" :label="item.name" width="80" :key="index" align="center" header-align="center" v-if="item.code.indexOf('imageUrl')!==-1">
              <template slot-scope="scope">
                <div class="list-pic" v-html="setImage(get(scope.row, item.code))" style="margin-left:-10px;margin-right:-10px;"></div>
              </template>
            </el-table-column>
            <!-- 排序 -->
            <el-table-column :prop="item.code" :label="item.name" width="80" :key="index" align="center" header-align="center" v-else-if="item.code.indexOf('sort')!==-1">
              <template slot-scope="scope">
                <el-input :value="get(scope.row, item.code)" @change="changeSort" @blur="blurSortInput(scope.row)"></el-input>
              </template>
            </el-table-column>
            <!-- 其他 -->
            <el-table-column :prop="item.code" :label="item.name" :width="item.width" align="center" header-align="center" :key="index" v-else>
              <template slot-scope="scope">
                <template v-if="item.computed"> {{item.computed(get(scope.row, item.code))}} </template>
                <template v-else> {{get(scope.row, item.code) | commonListfilter(item.code)}} </template>
              </template>
            </el-table-column>
          </template>
          <!-- 操作 -->
          <el-table-column v-else :label="item.name" :width="item.width" :key="index" align="center" header-align="center">
            <template slot-scope="scope">
              <template v-for="(value, i) in item.buttons">
                <!-- 方法跳转 -->
                <template v-if="value.onClick">
                  <template v-if="value.computed">
                    <el-button size="small" :type="value.type" @click="value.onClick(scope.$index, scope.row)" :key="i" style="margin:0 5px;" v-show="value.computed(scope.$index, scope.row)">{{value.value}}</el-button>
                  </template>
                  <template v-else>
                    <el-button size="small" :type="value.type" @click="value.onClick(scope.$index, scope.row)" :key="i" style="margin:0 5px;">{{value.value}}</el-button>
                  </template>
                </template>
                <!-- 链接跳转 -->
                <template v-else>
                  <router-link :target="value.target || '_self'" :to="setLink(value, scope.row)" :key="i" style="margin:0 5px;">
                    <el-button size="small" :type="value.type">{{value.value}}</el-button>
                  </router-link>
                </template>
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <!-- 翻页 -->
    <div class="main-page" v-if="isPage">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]" :current-page.sync="currentPage" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal"></el-pagination>
    </div>
    <!-- 列表项 -->
    <el-dialog title="列表项" :visible.sync="listItemVisible" @close="closeListItem">
      <el-table :data="listItem" row-key="uid">
        <el-table-column type="index" label="编号" width="66" align="center"></el-table-column>
        <el-table-column property="name" label="名称"></el-table-column>
        <el-table-column label="排序">
          <template slot-scope="scope">
            <el-input type="number" v-model="scope.row.sort" @blur="updateSortListItem(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="显示">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.isShow" active-text="是" inactive-text="否" :active-value="1" :inactive-value="0" @change="isShowListItem(scope.row)"></el-switch>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {
  fetchThead,
  fetchUserThead,
  isShowThead,
  updateSortThead
} from '@/api/base'
import City from './city'
import get from 'lodash.get'
export default {
  components: { 'app-city': City },
  name: 'List',
  props: {
    filter: { type: Array }, // 筛选
    remote: { type: Object }, // 接口
    tableCode: { type: String }, // 列表项code
    tableHead: {
      type: Array,
      default: function() {
        return []
      }
    }, // 表头
    tableData: {
      type: Array,
      default: function() {
        return []
      }
    }, // 表格数据
    isShowNum: { type: Boolean, default: true }, // 是否显示索引
    isPage: { type: Boolean, default: true }, // 是否翻页
    isCheckbox: { type: Boolean, default: false }, // 多选
    isRadio: { type: Boolean, default: false } // 单选
  },
  data() {
    return {
      param: {}, // 列表接口参数
      tableHeadColumn: [],
      dataList: [],
      pageTotal: 0,
      pageSize: 10,
      currentPage: 1,
      isLoading: false,
      multipleSelection: null,
      selectInput: '',
      selectInputList: [],
      listItem: [],
      listItemVisible: false,
      radio: null,
      sortValue: null
    }
  },
  watch: {
    tableData: function(dataList) {
      this.dataList = dataList
    }
  },
  created() {
    // 接口参数默认值
    this.param = this.remote ? Object.assign({}, this.remote.param) : {}
    this.tableHeadColumn = this.tableHead
    // 自定义表格数据
    this.dataList = this.tableData
    // selectInput
    this.filter &&
      this.filter.forEach((item, index) => {
        if (item.type === 'selectInput') {
          this.selectInput = item.value
          this.selectInputList = item.options
        }
      })
    // 动态表头设置
    this.tableCode && this.fetchThead()
    // 设置远程筛选数据
    this.filter && this.setFetchFilter()
    // 获取列表
    this.remote && this.fetch()
  },
  methods: {
    get,
    // 表头查询
    fetchThead() {
      fetchThead({ tableCode: this.tableCode }).then(response => {
        let list = response.data.list || []
        this.tableHeadColumn = list.concat(this.tableHead)
      })
    },
    // 链接设置
    setLink(options = {}, row) {
      let href = options.link + this.get(row, options.code)
      if (options.search && options.search.length) {
        let search = []
        options.search.forEach(function(item) {
          search.push(`${item}=${row[item] || ''}`)
        }, this)
        href += '?' + search.join('&')
      }
      return href
    },
    // 请求列表数据
    fetch() {
      this.isLoading = true
      this.remote.fetch(this.param).then(response => {
        let data = response.data || {}
        this.dataList = data.list || []
        this.pageTotal = this.isPage ? data.totalCount || 1 : 0
        this.isLoading = false
      })
    },
    // 设置接口筛选的数据
    setFetchFilter() {
      this.filter.forEach(function(item) {
        item.fetch &&
          item.fetch().then(response => {
            item.options = response.data.list || []
          })
      }, this)
    },
    // 搜索
    search() {
      this.fetch()
      if (this.isPage) {
        this.currentPage = 1
        this.param.page.index = 1
      }
    },
    // 页数改变
    handleSizeChange(val) {
      this.pageSize = val
      this.param.page.size = val
      this.currentPage = 1
      this.param.page.index = 1
      this.fetch()
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.param.page.index = val
      this.fetch()
    },
    // 刷新列表
    refresh() {
      this.fetch()
    },
    // 设置列表图片
    setImage(value) {
      let url = ''
      if (!value) {
        url = '//www.zai-art.com/appwrapper_dist/appDefaultImage/empty.png'
      } else {
        url = /(http)|(https)|(\/\/)/gi.test(value)
          ? value.replace(/(^http:)|(^https:)/gi, '')
          : `//img.zai-art.com/${value}`
      }
      return `<img src="${url}?imageView2/1/w/80/h/80" _src="${url}" />`
    },
    // 单选
    changeRadio(val) {
      this.multipleSelection = val
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSelect(selection, row) {
      this.$emit('select', selection, row)
    },
    handleSelectAll(selection) {
      this.$emit('select-all', selection)
    },
    rowClick(row, event, column) {
      this.$emit('row-click', row, event, column)
    },
    // 联动搜索
    changeSelectInput(value) {
      let oldValue = null
      this.selectInputList.forEach(item => {
        if (this.param[item.value]) {
          oldValue = this.param[item.value]
        }
        this.param[item.value] = null
      })
      this.param[value] = oldValue
      this.search()
    },
    // 日期改变
    changeDatePicker(key) {
      // this.param[key] = this.$refs['datePicker_' + key][0].displayValue
      this.search()
    },
    // 显示列表项
    openListItem() {
      this.listItemVisible = true
      this.fetchUserThead()
    },
    // 关闭列表项
    closeListItem() {
      this.listItem.length = 0
      this.fetchThead()
      this.refresh()
    },
    // 查询用户表头
    fetchUserThead() {
      fetchUserThead({ tableCode: this.tableCode }).then(response => {
        this.listItem.length = 0
        this.listItem = response.data.list || []
      })
    },
    // 表头排序
    updateSortListItem(row) {
      let param = {
        sort: row.sort || 0,
        uid: row.uid,
        tableCode: row.tableCode
      }
      updateSortThead(param).then(response => {
        this.fetchUserThead()
      })
    },
    // 是否显示表头
    isShowListItem(row) {
      let param = {
        isShow: row.isShow,
        uid: row.uid,
        tableCode: row.tableCode
      }
      isShowThead(param).then(response => {
        this.fetchUserThead()
      })
    },
    setRowKey(row) {
      if (row.id) return row.id
      if (row.goodInfo && row.goodInfo.id) return row.goodInfo.id
    },
    changeSort(value) {
      this.sortValue = value
    },
    blurSortInput(data) {
      if (this.sortValue) {
        this.$emit('changeSort', this.sortValue, data)
        this.sortValue = null
      }
    }
  }
}
</script>
<style scope>
@media screen and (max-width: 768px) {
  .main-page .el-pagination__total,
  .main-page .el-pagination__sizes,
  .main-page .el-pagination__jump {
    display: none !important;
  }
}

.list-block-control {
  /* border-top: 1px solid #eaeefb; */
  border-bottom: 1px solid #eaeefb;
  height: 36px;
  box-sizing: border-box;
  background-color: #fff;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  text-align: center;
  color: #d3dce6;
  cursor: pointer;
  transition: 0.2s;
  position: relative;
}

.list-block-control i {
  font-size: 12px;
  line-height: 36px;
}

.list-block-control:hover {
  color: #20a0ff;
}
.list-radio .el-radio__label {
  display: none;
}
.el-table .cell {
  max-height: 80px;
}
</style>
